<div class="typing" *ngIf="typing">
  <div class="snippet" data-title=".dot-flashing">
    <div class="stage">
      <div class="dot-flashing"></div>
    </div>
  </div>
  {{typing?.name + ' typing...' }}
</div>
<form action="" [formGroup]="form" (ngSubmit)="handleSendMessage()">
  <div class="message-form__message-container" [class.message-form__message-container--error]="form.hasError('server')">
    <div *ngIf="isShowAttachment" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="none center">
        <div *ngIf="editedMessage?.id" class="message-form__edit-icon" fxLayout fxLayoutAlign="center center">
          <mat-icon>edit</mat-icon>
        </div>
        <figure *ngIf="picture" class="message-form__attached-picture">
          <img [src]="picture" alt="image" />
          <span class="cross-mark" (click)="removeAttachment(); fileImage.value = ''"></span>
        </figure>
        <div *ngIf="attachmentName" fxLayout="row" fxLayoutAlign="center center" class="message-form__attached-file">
          <mat-icon>attachment</mat-icon>
          <span class="attachment-name">{{ attachmentName }}</span>
          <span class="cross-mark" (click)="removeAttachment(); fileImage.value = ''"></span>
        </div>
        <div *ngIf="editedMessage?.message" class="message-form__text" fxLayout="column">
          <p class="message-form__edit-label">{{ 'CLIENT.MESSENGER.CHAT_DETAILS.EDIT_TEXT_MESSAGE' | translate }}</p>
          <div class="message-form__edit-text" [innerHTML]="editedMessage.message"></div>
        </div>

        <button *ngIf="editedMessage?.id" class="message-form__edit-cancel" (click)="handleCancelMessageEdit()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>
    </div>

    <div class="message-form__input-container">
      <div class="message-form__attach-file" fxLayout fxLayoutAlign="center center">
        <img [class.g-disabled]="!!editedMessage?.id" src="assets/images/chat/attach-file.svg" (click)="fileImage.click()" alt="file" />
      </div>
      <div class="message-form__text">
        <input hidden type="file" (change)="uploadFile($event.target.files)" (click)="$event.target.value=null" #fileImage />
        <lin-chat-message-input formControlName="message" [placeholder]="'PLACEHOLDERS.WRITE_MESSAGE' | translate"></lin-chat-message-input>
      </div>
      <button
        class="message-form__send-btn"
        [class.g-disabled]="(loading$ | async) || !form.get('message').value && !form.get('attachment').value"
        type="submit"
      >
        <img *ngIf="(loading$ | async) === false; else spinner" src="assets/images/chat/send.svg" alt="send" />
        <ng-template #spinner>
          <mat-spinner class="mat-spinner-color" strokeWidth="2" diameter="20"></mat-spinner>
        </ng-template>
      </button>
    </div>
  </div>
</form>
